module.exports = __webpack_public_path__ + "static/media/Trainingb2ef2050.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/Training.svg
// module id = 1310
// module chunks = 0